import { SublayersWithPartners } from '@components/EntityDrawers/constants/common';
import { DashboardTabToSublayerMaps } from '@constants/entities/project-dashboard';
import { useDashboard } from '@context/DashboardContext';
import { useProject } from '@context/Project';
import {
  useProjectDashboardActions,
  useProjectDashboardFilters,
} from '@store/zustand/project-dashboard-filters';
import Filters from '@views/Project/components/Filters/Filters';
import PartnersFilterSelector from '@views/Project/components/Toolbox/components/PartnersFilterSelector';

const DashboardFilters = () => {
  const { partners } = useProjectDashboardFilters();
  const { clearDashboardFilters, setPartners } = useProjectDashboardActions();
  const { tab } = useDashboard();
  const {
    toolbox: { mode },
  } = useProject();

  const currentSublayer = mode
    ? (DashboardTabToSublayerMaps as Record<string, any>)[mode]?.[tab]
    : undefined;

  const shouldShowPartnerFilter = currentSublayer
    ? SublayersWithPartners.includes(currentSublayer)
    : false;

  return (
    <Filters
      count={partners.length}
      onClearFilters={clearDashboardFilters}
      disabled={!shouldShowPartnerFilter}
    >
      <PartnersFilterSelector partners={partners} onChange={setPartners} />
    </Filters>
  );
};

export default DashboardFilters;
